import { React, PropTypes, UI, TextField, useIntl, useSelector, isSubmittingSelector } from '../../dependencies';

const { InputWrapper } = UI;

const StreetField = ({ formId, ...rest }) => {
    const intl = useIntl();
    const submitting = useSelector(isSubmittingSelector(formId));

    return (
        <InputWrapper>
            <TextField
                name="street"
                placeholder={intl.formatMessage({
                    id: `supplier.form.street.placeholder`,
                })}
                disabled={submitting}
                {...rest}
            />
        </InputWrapper>
    );
};

StreetField.propTypes = {
    formId: PropTypes.string.isRequired,
    tabIndex: PropTypes.number.isRequired,
};

export default React.memo(StreetField);
